import { useEffect, useState } from 'react';
import { TextField } from '@recargas-dominicanas/core/components';
import { type IBankAccountConfig } from '@recargas-dominicanas/core/types';
import { useForm, validators } from '@recargas-dominicanas/core/utils';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './edit-modal.module.css';

interface Props {
  open: boolean;
  title: string;
  config?: IBankAccountConfig;
  errorMessage: string;
  onClose: () => void;
  onSave: (key: string, value: string) => Promise<void>;
}

export function EditModal(props: Props) {

  const {
    open,
    title,
    errorMessage,
    config,
    onSave,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  const [disabledButton, setDisabledButton] = useState(false);
  const form = useForm({ key: '', value: '' });

  useEffect(() => {
    if (open && config?.key && config?.value) {
      form.fields.key.update(config.key);
      form.fields.value.update(config.value);
    }
  }, [open, config?.key, config?.value]);

  function handleCancel() {
    form.clear();
    onClose();
    setError(undefined);
  }

  async function handleSave() {
    
    if (!form.isValid()) return;

    setDisabledButton(true);

    try {

      await onSave(form.value.key, form.value.value);
      handleCancel();

    } catch {

      setError(errorMessage);
    }

    setDisabledButton(false);
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title={title}
      error={error}
      secondaryButton='Guardar'
      disabledSecondaryButton={disabledButton}
      onClose={handleCancel}
      onSecondaryClick={handleSave}>
      <TextField
        style={style.textField}
        label='Nombre'
        formField={form.fields.key}
        validators={[validators.required]}/>
      <TextField
        style={style.textField}
        label='Valor'
        formField={form.fields.value}
        validators={[validators.required]}/>
    </Modal>
  );
}
